export default "__VITE_ASSET__HjlTajOy__"